import styled from 'styled-components';

import { Colors } from 'modules/ui/theme/colors';
import { HighlightedSm } from 'modules/ui/typography';

export const Button = styled.button<{ isActive?: boolean }>`
  width: 28px;
  height: 28px;
  background-color: ${({ isActive }): string =>
    isActive ? Colors.Primary : 'transparent'};
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  outline: none;
  box-shadow: ${({ isActive }): string =>
    isActive ? '0px 4px 12px rgba(1, 7, 36, 0.07)' : 'none'};
  border-radius: 4px;
  :active {
    background-color: ${Colors.PrimaryDark};
  }
  :hover {
    cursor: pointer;
  }
`;

export const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CountIndicator = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 16px;
  background-color: ${Colors.Secondary};
  position: absolute;
  top: -6px;
  right: -6px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const IndicatorText = styled(HighlightedSm)`
  color: ${Colors.White};
`;
